// frontend/src/context/AuthContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children, onLogin, onLogout }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
  }, []);

  const login = async (
    email,
    password,
    shop_id = null,
    shop_currency = null,
  ) => {
    const { data } = await api.post("/api/auth/login", {
      email,
      password,
      shop_id,
    });

    const enrichedUser = {
      ...data.user,
      shop_currency: shop_currency || data.user.shop_currency || "UGX",
    };

    api.defaults.headers.common["Authorization"] = `Bearer ${data.token}`;
    setUser(enrichedUser);
    if (onLogin) onLogin(enrichedUser.role);
    return enrichedUser;
  };

  const logout = () => {
    delete api.defaults.headers.common["Authorization"];
    setUser(null);
    if (onLogout) onLogout();
    window.location.href = "/login";
  };

  const can = (...roles) => user && roles.includes(user.role);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, can }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
